import Modal from './Modal';
import ModalUtils from './ModalUtils';
import IAlertModalConfig from './IAlertModalConfig';

class AlertModal extends Modal {
  
  private static readonly alertDefaults: IAlertModalConfig = {
    ...Modal.defaults,
    labelBtnAccept: 'Close',
    closeButtonInHeader: false
  };
  
  constructor(config_: Partial<IAlertModalConfig>) {
    const config = {
      ...AlertModal.alertDefaults,
      ...config_,
      ariaRole: 'alertdialog',
    };

    if (!config.describedById) {
      console.warn('No `describedById` given for AlertModal');
    }

    const $closeBtn = ModalUtils.makePrimaryButton(config.labelBtnAccept)[0];

    $closeBtn.setAttribute('data-dismiss', 'modal');

    config.footerContents = [
      $closeBtn,
    ];

    super(config);
  }
}

export default AlertModal;
